import { Offer } from "../models/shared/Offer";
import { PlaceGeocoding } from "../models/shared/Place";

export const calculateNewOrder = (oldOrder: string[], movedId: string, targetId: string) => {
    const newOrder: string[] = [];

    if (movedId === targetId) {
        return oldOrder;
    }

    for (let ix = 0; ix < oldOrder.length; ix++) {
        if (oldOrder[ix] === movedId) {
            continue;
        }

        if (oldOrder[ix] === targetId) {

            newOrder.push(movedId);
        }
        newOrder.push(oldOrder[ix]);
    }

    if (!targetId) {
        newOrder.push(movedId);
    }


    return newOrder;
}

export const isMobileDevice = () => {
    return /Mobi|Android|iPad|Tablet/i.test(navigator.userAgent);
}

export const isIOSDevice = () => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

// iOS expects "sms:<phone>&body=", Android "sms:<phone>?body="
export const createSmsLink = (phone: string, body: string) => {
    const separator = isIOSDevice() ? '&' : '?';
    return `sms:${phone.replace(/[^\d+]/g, '')}${separator}body=${encodeURIComponent(body)}`;
}

export const navigateOnMap = (geocoding: PlaceGeocoding | undefined) => {
    const { lat, lng } = geocoding || {};
    const geoUrl = `geo:${lat},${lng}?q=${lat},${lng}`;
    const fallbackUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

    if (isMobileDevice()) {
        window.open(geoUrl, '_blank');
    } else {
        window.open(fallbackUrl, '_blank');
    }
}


export const getLatestOffer = (offers: Offer[]) => {
    if (!offers || offers.length === 0) return null

    // First try to find an accepted offer
    const acceptedOffers = offers.filter(o => o.acceptedAt)
    if (acceptedOffers.length > 0) {
        // Sort by acceptedAt descending
        return acceptedOffers.sort((a, b) =>
            (b.acceptedAt?.getTime() || 0) - (a.acceptedAt?.getTime() || 0)
        )[0]
    }

    // Otherwise, get the latest active offer
    const activeOffers = offers.filter(o => o.status === 'active')
    if (activeOffers.length === 0) return null

    // Sort by updatedAt descending
    return activeOffers.sort((a, b) =>
        b.updatedAt.getTime() - a.updatedAt.getTime()
    )[0]
}
